import React from "react";
import { Provider as StateProvider } from "react-redux";
import ThemeProvider from "shared/components/ThemeProvider";
import theme from "shared/skin";
import store from "services/state/store";

const Provider = ({ children }) => (
  <ThemeProvider theme={theme}>
    <StateProvider store={store}>{children}</StateProvider>
  </ThemeProvider>
);

export default Provider;



// WEBPACK FOOTER //
// ./src/Provider.js